<template>
    <div>
        <rkm-row
            v-if="!hideFilters && !$slots['filters']"
            class="datatable-header"
        >
            <rkm-col>
                <rkm-form-input
                    placeholder="Digite para buscar"
                    v-model="localFieldFilter"
                    @keyup.native.enter="handleEnterKey"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-form-select
                            :options="searchOptions"
                            class="m-0"
                            v-model="localSearchOption"
                        />
                    </rkm-input-group-prepend>

                    <rkm-input-group-append slot="append">
                        <rkm-button
                            :disabled="localFieldFilter || !disabledButtonSearch ? false : true"
                            @click="search"
                            color="primary"
                            class="btn-search"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :disabled="!localFieldFilter"
                            @click="clear"
                            class="btn-clear"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <slot name="filters" />

        <rkm-row>
            <rkm-col>
                <slot name="beforeTable" />

                <b-table
                    :busy="busy"
                    :current-page="currentPage"
                    :fields="localFields"
                    :filter="localFilter"
                    :foot-clone="footClone"
                    :items="items"
                    :no-footer-sorting="noFooterSorting"
                    :per-page="perPage"
                    :responsive="responsive"
                    :sort-by="localSortBy"
                    :sort-desc="localSortDesc"
                    :tbody-tr-class="tbodyTrClass"
                    @filtered="$emit('filtered', $event)"
                    empty-filtered-text="Não há registros correspondentes à sua solicitação"
                    empty-text="Não há registros para exibir"
                    hover
                    outlined
                    ref="table"
                    show-empty
                    sort-icon-left
                    striped
                >
                    <template v-slot:table-busy>
                        <div class="text-center">
                            <rkm-icon icon="circle-notch" loading /> carregando...
                        </div>
                    </template>

                    <template #empty="scope"><div class="text-center">{{ scope.emptyText }}</div></template>
                    <template #emptyfiltered="scope"><div class="text-center">{{ scope.emptyFilteredText }}</div></template>

                    <template
                        v-for="(_, name) in $scopedSlots"
                        :slot="name"
                        slot-scope="data"
                    >
                        <slot
                            :name="name"
                            v-bind="data"
                        />
                    </template>
                </b-table>

                <slot name="afterTable" />
            </rkm-col>
        </rkm-row>

        <rkm-row class="datatable-footer">
            <rkm-col>
                <rkm-row class="align-items-center">
                    <rkm-col
                        cols="auto"
                    >
                        <b-pagination
                            :per-page="perPage"
                            :total-rows="recordsFiltered"
                            v-model="currentPage"
                        />
                    </rkm-col>

                    <rkm-col
                        v-if="!busy"
                        cols="auto"
                    >
                        <template v-if="recordsFiltered > 0">
                            Exibindo do {{ ((currentPage - 1) * perPage) + 1 }}
                            ao {{ currentPage * perPage }}
                            de {{ recordsFiltered }} registro(s)
                        </template>

                        <template v-if="recordsTotal">
                            (Filtrado de {{ recordsTotal }} registros totais)
                        </template>
                    </rkm-col>
                </rkm-row>
            </rkm-col>

            <rkm-col
                cols="auto"
            >
                <rkm-form-group
                    label-align="left"
                    label-cols="auto"
                    label="Por página"
                >
                    <rkm-form-select
                        :options="pageOptions"
                        v-model="perPage"
                    />
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <slot name="afterPagination" />
    </div>
</template>

<script>
// Components.
import { BTable, BPagination } from 'bootstrap-vue'

// Mixins.
import { repository, stringCase } from '@/mixins'

export default {
    components: { BTable, BPagination },
    computed: {
        searchOptions() {
            return this.fields.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
        localFields() {
            return this.fields.filter(f => (typeof (f.visible) === 'boolean' ? f.visible : true) === true)
        },
    },
    created() {

        this.localSortBy = this.sortBy
        this.localSortDesc = this.sortDesc
        this.localSearchTable = this.searchTable
    },
    data: () => ({
        busy: false,
        currentPage: 1,
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: null,
        localSortDesc: false,
        pageOptions: [10, 50, 100],
        perPage: 10,
        oldPerPage: null,
        recordsFiltered: 0,
        recordsTotal: 0,
        localSearchTable: false,
        dataItems: null,
    }),
    methods: {
        search() {

            this.localSearchTable = true
            this.dataItems = null
            this.previousPage = null
            this.localSortBy = this.sortBy
            this.oldPerPage = this.perPage
            this.localSortDesc = this.sortDesc

            this.localFilter = this.localFieldFilter;
            this.$refs.table.refresh();
        },
        clear() {
            this.localSearchOption = this.searchBy || this.searchOptions[0].value;
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.recordsFiltered = 0
            this.recordsTotal = 0
            this.localSearchTable = false
            this.dataItems = null
            this.previousPage = null

            this.$refs.table.refresh();
        },
        handleEnterKey(event) {

            if (event.key === 'Enter' && (this.localFieldFilter || !this.disabledButtonSearch)) {
                this.search();
            }
        },
        items(context) {

            if (!this.searchTable && !this.localSearchTable) {
                return []
            }

            context.filter = context.filter == null ? this.filter : context.filter

            if (this.handleItems(context)) {

                const filter = (context.filter && typeof context.filter === 'string') ? context.filter.trim() : '';

                if (!filter || filter === '') {
                    this.localFilter = null;
                } else {
                    this.localFilter = filter;
                }

                this.previousPage = context.currentPage

                const sortBy = context.sortBy.trim()
                const sortDesc = context.sortDesc
                this.oldPerPage = context.perPage

                this.busy = true

                const params = {
                    columns: this.fields.map(field => ({
                        data: this.camelToSnake(field.key),
                        name: this.camelToSnake(field.name || ''),
                        orderable: !!(field.sortable || false),
                        searchable: field.key === this.localSearchOption,
                    })),
                    draw: filter.length,
                    length: context.perPage,
                    search: { value: filter },
                    start: ((context.currentPage - 1) * context.perPage).toString(),
                }

                if (sortBy) {
                    let order = [{
                        column: this.fields.findIndex(field => field.key == sortBy),
                        dir: sortDesc ? 'desc' : 'asc',
                        columnName: this.fields.find(field => field.key == sortBy).key,
                    }]

                    Object.assign(params, { order })
                }

                return this.repository.datatable({...params, ...this.requestParams}).then(response => {
                    const items = response.data

                    this.recordsFiltered = items.recordsFiltered
                    this.recordsTotal = items.recordsTotal
                    this.localSortDesc = sortDesc
                    this.localSortBy = sortBy
                    this.busy = false

                    this.dataItems = items.data

                    return items.data
                })
            } else {

                return this.dataItems
            }
        },
        handleItems(context) {

            return !this.dataItems || context.currentPage !== this.previousPage
                || context.sortBy.trim() !== this.localSortBy || context.sortDesc !== this.localSortDesc
                || context.perPage !== this.oldPerPage
        },
        refresh() {
            this.search();
        },
    },
    mounted() {
        if (this.searchOptions.length > 0) {
            this.localSearchOption = this.searchBy || this.searchOptions[0].value
        }
    },
    props: {
        fields: { type: Array, default: null },
        filter: { type: String, default: null },
        footClone: { type: Boolean, default: false },
        hideFilters: { type: Boolean, default: false },
        noFooterSorting: { type: Boolean, default: false },
        repository: { type: Object, required: true },
        requestParams: { type: Object },
        responsive: { type: Boolean, default: false },
        sortBy: { type: String, default: null },
        sortDesc: { type: Boolean, default: false },
        tbodyTrClass: { type: Function },
        searchBy: { type: String, default: null },
        resetTable: { type: Boolean, default: false },
        disabledButtonSearch: { type: Boolean, default: false },
        searchTable: { type: Boolean, default: false },
    },
    mixins: [ repository, stringCase ],
    watch: {
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {

            this.clearSearchOption()
        },
        'localFieldFilter': function () {

            this.clearTable()
        },
        'searchBy': function () {

            if (this.searchOptions.length > 0) {
                this.localSearchOption = this.searchBy
            }
        },
        'resetTable': function () {

            if (this.resetTable) {
                this.clearTable()
            }
        },
    },
}
</script>

<style scoped>
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>